export default __webpack_public_path__ + "static/verso-2-f8e04780dba735fd8d539089b92f6f65.jpg";